import * as settings from '../settings.js';
import { GT_OSGB, GT_WGS84 } from '../geotools';
import { Styles } from '../classes/Styles';
import { colors } from '../state';
import { sortByKey, setCursor, showError } from '../helpers';
import { downloadCSV } from '../FileFunctions/index.js';
const styles = new Styles();
export function clearInsight({ ol, state }) {
  ol.layers.planningLayer.destroyFeatures();
  ol.layers.planningLayer.redraw();
  ol.layers.planningLayer.setZIndex(2007);
  state.planningActive = false;
  $('#totalPlanning').text('');
}
export function getPlanningApplications({ state, ol }) {
  const planningApplications = $('#planning-list').val();
  const ref = $('#planning-ref').val();
  let count = 0;
  $.ajax({
    url: `${settings.baseURL}/nodeservice/planning?planningApplications=${planningApplications}&ref=${ref}`,
    type: 'GET',
    dataType: 'json',
    crossDomain: true,
    success: function (result, textStatus, request) {
      var wgs84 = new GT_WGS84();
      result.forEach(collection => {
        count++;
        wgs84.setDegrees(collection.location.coordinates[1], collection.location.coordinates[0]);
        var osgb2 = wgs84.getOSGB();
        var newStyle = {};
        jQuery.extend(newStyle, styles.defaultStyle);
        var point = new OpenLayers.Geometry.Point(osgb2.eastings, osgb2.northings);
        var feat = new OpenLayers.Feature.Vector(
          point,
          null,
          styles.augment(newStyle, colors.orange, 2, 1, colors.orange),
        );
        feat.style.pointRadius = '12';
        if (count == 8 || count == 10) feat.style.label = '8,10';
        else feat.style.label = count.toString();
        feat.style.labelAlign = 'cm';
        feat.style.fontColor = '#000000';
        feat.style.fontSize = '10px';
        feat.style.fontFamily = 'Arial';
        feat.style.fontWeight = 'bold';
        feat.style.strokeColor = colors.planning;
        feat.style.fillOpacity = 0.75;
        feat.style.strokeWidth = 1;

        ol.layers.vector2.addFeatures([feat]);
      });
      ol.layers.vector2.redraw();
      state.planningActive = false;
    },
  });
}
export function getInsight({ state, ol }) {
  if (!state.callingInsight) {
    state.callingInsight = true;
    state.planningResults = [];
    var parser = new jsts.io.OpenLayersParser();
    var polyg = parser.read(state.planningFeat);
    if (polyg.shell) {
      polyg = polyg.shell;
    }
    var buffpoly = polyg.buffer(state.rad);
    var outpoly = parser.write(buffpoly);
    var linearRing = new OpenLayers.Geometry.LinearRing(outpoly.components[0].components);
    var lineString = new OpenLayers.Geometry.LineString(linearRing.components);
    var simp = 0.5;
    var newLineString = lineString.simplify(0.1);
    var ie = !!window.MSInputMethodContext && !!document.documentMode;
    var maxpoint = ie ? 30 : 50;
    while (newLineString.components.length > maxpoint) {
      simp += 0.1;
      newLineString = lineString.simplify(simp);
    }
    var newLinearRing = new OpenLayers.Geometry.LinearRing(newLineString.getVertices());
    var newPolygon = new OpenLayers.Geometry.Polygon(newLinearRing);
    var feat = new OpenLayers.Feature.Vector(newPolygon);
    var poly = feat.geometry.components[0].components;
    if (typeof poly[0].components !== 'undefined') {
      poly = poly[0].components;
    }
    var str = '[';
    for (var i = 0; i < poly.length; i++) {
      var conv = new GT_OSGB();
      conv.setGridCoordinates(poly[i].x, poly[i].y);
      var wgs = conv.getWGS84();
      str += '[' + wgs.longitude + ',' + wgs.latitude + '],';
    }
    str = str.substring(0, str.length - 1) + ']';
    state.planningPoly = str;
    var data = {
      polygon: state.planningPoly,
      limit: 1000,
    };
    var newStyle = {};
    //  var feat = state.planningFeat;
    jQuery.extend(newStyle, styles.propertyStyle);
    feat.style = styles.augment(newStyle, colors.planning, 2, 0);
    feat.type = 'property';
    feat.subtype = 'property';
    feat.style = newStyle;
    ol.layers.planningLayer.addFeatures([feat]);
    state.planningCenter = feat.geometry.getCentroid();
    callPlanning({ data, page: 1, state, ol });
  }
}
export function callPlanning({ data, page, jwt, state, ol }) {
  setTimeout(function () {
    $('#planning-range').prop('disabled', true);
  }, 200);
  setCursor({ type: 'progress' });
  data.page = page;
  $.ajax({
    url: settings.baseURL + '/proxy/planning',
    type: 'GET',
    dataType: 'json',
    crossDomain: true,
    data: data,
    beforeSend: function (xhr) {
      if (jwt) xhr.setRequestHeader('Query-JWT', jwt);
      //      xhr.setRequestHeader("X-Api-Key", landinsightAPIKey);
      xhr.setRequestHeader('Content-Type', 'application/json');
    },
    success: function (result, textStatus, request) {
      jwt = request.getResponseHeader('query-jwt');
      if (result.length === 100) {
        state.planningResults = state.planningResults.concat(sortByKey(result, 'date_received').reverse());
        if (page < 10) callPlanning({ data, page: page + 1, jwt, state, ol });
        else {
          showError({
            state,
            title: '<center>Maximum reached</center>',
            message:
              '<p>The search has reached the maximum limit of 1,000 planning application.  There may be more planning applications within your search area which can not be displayed</p><p>Reduce the search buffer to reveal a full planning history for the search area',
          });
          state.callingInsight = false;
          result = state.planningResults;
          $('#totalPlanning').text('(' + result.length + ')');
          setupPlanning({ result, state, ol });
        }
      } else if (result.length > 0 || (result.length === 0 && page !== 1)) {
        result = state.planningResults.concat(sortByKey(result, 'decision_date').reverse());
        $('#totalPlanning').text('(' + result.length + ')');
        state.callingInsight = false;
        setupPlanning({ result, state, ol });
      } else {
        $('#totalPlanning').text('');
        setTimeout(function () {
          $('#planning-range').removeAttr('disabled');
        }, 200);
        if ($('#planning-range')[0].value !== '75') {
          state.callingInsight = false;
          showError({
            state,
            title: '<center>No planning applications</center>',
            message:
              '<p>No planning applications found within the selected polygon</p><p>Increase the search buffer to reveal nearby planning applications</p>',
          });
        } else {
          state.callingInsight = false;
          showError({
            state,
            title: '<center>No planning applications</center>',
            message:
              '<p>Our data provider has not found any planning applications within the search area.<p><p>To increase the search area, draw a new larger polygon using the "Draw Other" tool and use that area as the selected polygon.</p>',
          });
        }
      }
    },
    error: function () {
      state.callingInsight = false;
      showError({ state, title: 'Warning', message: 'Unable to contact planning application service' });
    },
  });
}
export function setupPlanning({ result, state, ol }) {
  setTimeout(function () {
    $('#planning-range').removeAttr('disabled');
  }, 200);
  setCursor({ type: 'help' });
  var collection = [];
  state.csvArray = [];
  var count = 0;
  for (var m = 0; m < result.length; m++) {
    if (!result[m].search_result.title) {
      result[m].search_result.title = 'no title';
    }
    state.csvArray.push(result[m].search_result);
    let found = false;
    if (collection.length == 0) {
      collection[0] = [];
      collection[0].push(result[m].search_result);
    } else {
      for (var n = 0; n < collection.length; n++) {
        if (collection[n] === 'undefined') {
          collection[n] = [];
          collection[n].push(result[m].search_result);
        } else {
          var current = collection[n][0];
          if (
            Math.abs(current.location.coordinates[0] - result[m].search_result.location.coordinates[0]) < 0.0001 &&
            Math.abs(current.location.coordinates[1] - result[m].search_result.location.coordinates[1]) < 0.0001
          ) {
            //          if (current.location.coordinates[0] == result[m].location.coordinates[0] && current.location.coordinates[1] == result[m].location.coordinates[1]) {
            collection[n].push(result[m].search_result);
            found = true;
            break;
          }
        }
      }
      if (!found) {
        count++;
        collection[count] = [];
        collection[count].push(result[m].search_result);
      }
    }
  }

  $('#csv-link').show();
  $('#planning_settings').show();
  var wgs84 = new GT_WGS84();
  count = 0;
  for (var i = 0; i < collection.length; i++) {
    wgs84.setDegrees(collection[i][0].location.coordinates[1], collection[i][0].location.coordinates[0]);
    var osgb2 = wgs84.getOSGB();
    var newStyle = {};
    jQuery.extend(newStyle, styles.defaultStyle);
    var point = new OpenLayers.Geometry.Point(osgb2.eastings, osgb2.northings);
    var feat = new OpenLayers.Feature.Vector(point, null, styles.augment(newStyle, colors.orange, 2, 1, colors.orange));
    feat.style.pointRadius = '12';
    feat.style.label = collection[i].length.toString();
    feat.style.labelAlign = 'cm';
    feat.style.fontColor = '#000000';
    feat.style.fontSize = '10px';
    feat.style.fontFamily = 'Arial';
    feat.style.fontWeight = 'bold';
    feat.attributes = collection[i];
    for (n = 0; n < feat.attributes.length; n++) {
      var xdist = Math.pow(Math.abs(feat.geometry.x - state.planningCenter.x), 2);
      var ydist = Math.pow(Math.abs(feat.geometry.y - state.planningCenter.y), 2);
      var dist = Math.sqrt(xdist + ydist).toFixed(1) + 'm';
      feat.attributes[n].distance = dist;
      state.csvArray[count].distance = dist;
      feat.attributes[n].flagged = '';
      state.csvArray[count].flagged = '';
      count++;
    }
    feat.style.strokeColor = colors.planning;
    feat.style.strokeWidth = 1;

    ol.layers.planningLayer.addFeatures([feat]);
  }
  ol.layers.planningLayer.redraw();
  state.planningActive = false;
  $('#csv-link')
    .off()
    .click(() => {
      downloadCSV({}, state);
    });
}
